// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"179f6bc5","238":"21605ab6","686":"c98399b9"}[chunkId] + ".chunk.js";
};